import * as z from "zod";

export const reportPasswordLoginError = {
  name: "reportPasswordLoginError" as const,
  input: z.object({
    email: z.email(),
    errorName: z.string().optional(),
    errorMessage: z.string().optional(),
    errorStack: z.string().optional(),
    userAgent: z.string().optional(),
    url: z.string().optional(),
  }),
  output: z.object({ ok: z.boolean() }),
};
